import React, { createContext, useReducer, useContext} from 'react';

export const AccountContext = createContext(null);
export const AccountContextDispatch = createContext(null);

export function AccountProvider({children}){
    const [account, dispatch] = useReducer(accountReducer, {accountDetails: {}, tokens: undefined, loggedIn: false, password: "", isLoggingOut: false, isAuthenticating: false});
    return(
        <AccountContext.Provider value={account}>
            <AccountContextDispatch.Provider value={dispatch}>
                {children}
            </AccountContextDispatch.Provider>
        </AccountContext.Provider>
    )

}

function accountReducer(account, action){
    switch (action.type) {
        case 'login':
            return {...account, accountDetails: action.signin, loggedIn: true, password: action.passSecret}
        case 'tokens':
            account.accountDetails.tokens = action.tokens;

            // Update localStorage to keep it in sync
            try {
                const storedAccount = localStorage.getItem('account');
                if (storedAccount) {
                    const accountData = JSON.parse(storedAccount);
                    accountData.tokens = action.tokens;
                    localStorage.setItem('account', JSON.stringify(accountData));
                }
            } catch (error) {
                console.error('Failed to update tokens in localStorage:', error);
            }

            return {...account, tokens: action.tokens}
        case 'logout':
            return {...account, accountDetails: {}, tokens: undefined, loggedIn: false, isLoggingOut: false, isAuthenticating: false}
        case 'generation':
            let amount = account.accountDetails.tokens - action.amount;
            console.log("Before: ",account.accountDetails.tokens, " After: ", amount);
            account.accountDetails.tokens = amount;
            return {...account, tokens: account.tokens - action.amount}
        case 'updateOpenAIKey':
            // Create a new accountDetails object with the updated openaiKey
            const updatedDetails = {...account.accountDetails, openaiKey: action.openaiKey};
            console.log("OpenAI key updated in context");
            return {...account, accountDetails: updatedDetails};
        case 'updateGoogleAPIKey':
            // Create a new accountDetails object with the updated googleAPIKey
            const updatedGoogleDetails = {...account.accountDetails, googleAPIKey: action.googleAPIKey};
            console.log("Google API key updated in context");
            return {...account, accountDetails: updatedGoogleDetails};
        case 'setLoggingOut':
            return {...account, isLoggingOut: action.value};
        case 'setAuthenticating':
            return {...account, isAuthenticating: action.value};
        default:
            return {account}
    }
}

export function useAccountContext() {
    return useContext(AccountContext);
}

export function useAccountContextDispatch() {
    return useContext(AccountContextDispatch);
}